import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  middleWidth: {
  },
  ctnModal: {
    backgroundColor: '#fff',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 4),
    top: '35%',
    margin: 'auto',
    borderRadius: '20px',
    overflow: 'hidden',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '480px !important',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 26px',
      width: '300px !important',
    },
    '& > span': {
      textAlign: 'center'
    },
    '& > #title': {
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: '28px'
    },
    '& > #desc': {
      lineHeight: '20px',
      marginTop: '4px'
    }
  },
  rowStyle: {
    marginTop: '20px',
    '& > .MuiButton-text': {
      padding: '6px 44px',
      textTransform: 'none'
    },
    '& > .MuiButton-text:first-child': {
      background: '#f4f4f4',
      border: '1px solid #ddd'
    },
    '& > .MuiButton-text:last-child': {
      marginLeft: '12px',
      background: theme.palette.primary.gradient,
    },
  },
  btnNo: {
    background: '#403DE3 !important',
    '& > .MuiButton-label': {
      color: '#fff'
    }
  },
  circularStyle: {
    color: '#fdc12c',
  }
}));

export default useStyles;
